var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 16,
    viewBox: "0 0 70 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 16,
    rx: 8,
    fill: "#02BF8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.048 3.996L15.6 12.516L19.152 3.996H17.832L15.6 9.576L13.368 3.996H12.048ZM24.5713 3.996H20.1553V12H24.5713V10.848H21.3793V8.328H24.4753V7.176H21.3793V5.148H24.5713V3.996ZM26.1553 3.996V12H27.3793V8.724H27.5953L29.8873 12H31.3633L28.8673 8.58C29.9353 8.34 30.6433 7.5 30.6433 6.348C30.6433 6 30.5713 5.052 29.6953 4.464C29.1793 4.116 28.5553 3.996 27.5833 3.996H26.1553ZM27.3793 5.124H27.7993C28.3993 5.124 29.4673 5.232 29.4673 6.36C29.4673 7.632 28.0993 7.668 27.7633 7.668H27.3793V5.124ZM32.5655 3.996V12H33.7895V3.996H32.5655ZM39.7141 3.996H35.7061V12H36.9301V8.328H39.6181V7.176H36.9301V5.148H39.7141V3.996ZM41.1084 3.996V12H42.3324V3.996H41.1084ZM48.6651 3.996H44.2491V12H48.6651V10.848H45.4731V8.328H48.5691V7.176H45.4731V5.148H48.6651V3.996ZM50.2491 3.996V12H51.9051C53.0211 12 53.8971 11.892 54.8331 11.232C55.8891 10.488 56.4411 9.336 56.4411 8.004C56.4411 6.672 55.8771 5.508 54.9051 4.776C54.0171 4.116 53.0451 3.996 51.9291 3.996H50.2491ZM51.4731 5.148H52.0011C52.5891 5.148 53.4411 5.196 54.1371 5.7C54.7131 6.12 55.2171 6.948 55.2171 8.004C55.2171 9.096 54.6771 9.864 54.1251 10.284C53.4291 10.8 52.6011 10.848 52.0011 10.848H51.4731V5.148Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedButton);
export default __webpack_public_path__ + "static/media/verified_button.b84b0422.svg";
export { ForwardRef as ReactComponent };